import { render, staticRenderFns } from "./DocsLibraryLink.vue?vue&type=template&id=42f4c0bc"
import script from "./DocsLibraryLink.vue?vue&type=script&lang=js"
export * from "./DocsLibraryLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports